import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MemoryRouter } from "react-router-dom";
import App from "./App.jsx";
import { initBranch } from "./utils/branchService.js";
import "./hooks/useDigilocker.js";
import "./hooks/useIncomeVerification.js";
import "./styles/main.scss";

window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

// Save redirect URL for third party flows before MemoryRouter clears it
const initialPath = window.location.pathname + window.location.search;
if (initialPath !== "/" && initialPath !== "/index.html" && initialPath !== "") {
  localStorage.setItem("pendingNetBankingCallbackUrl", initialPath);
}

// Initialize Branch, and ONLY wipe the URL clean AFTER Branch has finished reading it
initBranch().finally(() => {
  window.history.replaceState(null, "", "/");
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <MemoryRouter>
      <App />
    </MemoryRouter>
  </StrictMode>
);
